import { Input } from 'reactstrap'
import Cell from './Cell'
import Cols from './Cols'
import Head from './Head'

const Section = ({ dispatch, ...props }) => (
	<table className='checklist-table'>
		<Cols dispatch={dispatch} {...props} />
		<Head {...props} />
		<tbody>
			{props.items.map((item, index) => (
				<tr key={item.id}>
					<td className='checklist-td'>{item.name}</td>
					<Cell
						status={props.status}
						item={item}
						sectionId={props.sectionId}
						inputRadioId={`radio1-${item.id}`}
						value='1'
						onChangeItem={props.onChangeItem}
						dispatch={dispatch}
					/>
					<Cell
						status={props.status}
						item={item}
						inputRadioId={`radio2-${item.id}`}
						sectionId={props.sectionId}
						value={props.rating === 'yes-no' ? 0 : 2}
						onChangeItem={props.onChangeItem}
						dispatch={dispatch}
					/>
					{props.rating !== 'yes-no' ? (
						<Cell
							item={item}
							sectionId={props.sectionId}
							inputRadioId={`yes-no-${item.id}`}
							value='3'
							onChangeItem={props.onChangeItem}
							dispatch={dispatch}
							status={props.status}
						/>
					) : null}
					<td className='checklist-td'>
						<Input
							rows='4'
							type='textarea'
							name='comment'
							id='comment'
							value={item.comment}
							onChange={(event) =>
								dispatch(
									props.onChangeComment(
										event.target.value,
										props.sectionId,
										item.id
									)
								)
							}
							readOnly={props.status === 'submit'}
						/>
					</td>
				</tr>
			))}
		</tbody>
	</table>
)

export default Section
